export enum SalesSheetType {
  PRIVATE_MARKETS = 'Private',
  TENDER = 'Tender',
}

export enum SalesSheetStatus {
  PENDING = 'Pending',
  PROCESSING = 'Processing',
  INVALID_SHEET_DATA = 'Invalid Sheet Data',
  DONE = 'Done',
  FAILED = 'Failed',
}

export interface Distributor {
  id: string;
  companyId: string;
  name: string;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CompanyDistributorsResponse {
  success: boolean;
  message: string;
  messageCode: string;
  data: {
    distributors: Distributor[];
  };
}

export interface SalesSheetUploadResponse {
  success: boolean;
  message: string;
  messageCode: string;
  data: {
    sheetId: string;
    status: SalesSheetStatus;
  };
}
